var elem = document.documentElement;

export function fullscreen(isFullscreen) {
  if (isFullscreen !== false) {
    openFullscreen();
  } else {
    closeFullscreen();
  }
}

function openFullscreen() {
  if (elem.requestFullscreen !== undefined && elem.requestFullscreen !== null) {
    elem.requestFullscreen();
  } else if (elem.webkitRequestFullscreen !== undefined && elem.webkitRequestFullscreen !== null) {
    elem.webkitRequestFullscreen();
  } else if (elem.msRequestFullscreen !== undefined && elem.msRequestFullscreen !== null) {
    elem.msRequestFullscreen();
  }
}

function closeFullscreen() {
  if (document.exitFullscreen !== undefined && document.exitFullscreen !== null) {
    document.exitFullscreen();
  } else if (document.webkitExitFullscreen !== undefined && document.webkitExitFullscreen !== null) {
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen !== undefined && document.msExitFullscreen !== null) {
    document.msExitFullscreen();
  }
}
